<template>
    <ModalContent
        flat-chrome
        :help-content-id="`popup-stock-${current_entity_profile}`"
    >
        <template slot="title">{{ title }}</template>
        <template slot="content">
            <PremiumFeatureGateWarehouses v-if="showWarehousesGate" />
            <template v-else
                ><div
                    class="stitch-modal general-settings-reference stitch-form"
                >
                    <v-card class="stitch-modal__card" elevation="0"
                        ><v-card-text
                            ><h5 class="stitch-modal__title">
                                <v-icon size="16">mdi-warehouse</v-icon
                                ><span>Information</span>
                            </h5>
                            <v-row class="mt-4">
                                <v-col cols="12" sm="6">
                                    <v-text-field
                                        outlined
                                        v-model="stock.name"
                                        hide-details="auto"
                                        :error-messages="
                                            stock_saving_errors?.name
                                        "
                                        :label="$translate('labels.name') + ' *'"
                                        :disabled="!isStockOwner"
                                        name="name"
                                        autofocus
                                        :dense="true"
                                        required
                                        @keydown="handleKeyPress"
                                    />
                                </v-col>

                                <v-col cols="12" sm="6">
                                    <v-text-field
                                        outlined
                                        v-model="stock.code"
                                        hide-details="auto"
                                        :error-messages="
                                            stock_saving_errors?.code
                                        "
                                        :label="
                                            $translate(
                                                'labels.code_automatically_generated'
                                            )
                                        "
                                        name="code"
                                        :disabled="!isStockOwner"
                                        :dense="true"
                                        @keydown="handleKeyPress"
                                    />
                                </v-col>

                                <v-col
                                    v-if="showEstablishmentField"
                                    cols="12"
                                    sm="6"
                                >
                                    <SearchEstablishment
                                        outlined
                                        :value="stock.establishment"
                                        @input="onEstablishmentInput"
                                        :label="
                                            $translate('labels.establishment')
                                        "
                                        :error-messages="
                                            stock_saving_errors?.establishment
                                        "
                                        :disabled="!isStockOwner"
                                        :allow-create="
                                            isStockOwner &&
                                            userHasPermission(
                                                'core.add_establishment'
                                            )
                                        "
                                        hide-details="auto"
                                        :dense="true"
                                        @keydown.native="handleKeyPress"
                                    />
                                </v-col>
                            </v-row> </v-card-text></v-card
                    ><v-card class="stitch-modal__card" elevation="0"
                        ><v-card-text
                            ><h5 class="stitch-modal__title">
                                <v-icon size="16">mdi-package-variant</v-icon
                                ><span>{{ $translate("stock_tracking") }}</span>
                            </h5>
                            <v-row class="mt-0 mb-6">
                                <v-col cols="12" class="mt-0">
                                    <v-checkbox
                                        v-model="stock.track_stock"
                                        :disabled="!isStockOwner"
                                        :label="
                                            $translate('enable_stock_tracking')
                                        "
                                        hide-details
                                        class="mt-0"
                                    />
                                    <p
                                        class="text-caption text--secondary mb-0 mt-2"
                                    >
                                        {{
                                            $translate(
                                                "stock_tracking_explanation"
                                            )
                                        }}
                                    </p>
                                </v-col>
                            </v-row>

                            </v-card-text></v-card>
                            <v-card v-if="stock.track_stock" class="stitch-modal__card" elevation="0"><v-card-text>
                                <h5 class="stitch-modal__title"><v-icon size="16">mdi-map-marker-multiple-outline</v-icon><span>{{ $translate('storageLocationsTitle') }}</span></h5>
                                <StorageLocationsEditor :value="stock.storage_locations" @input="onStorageLocationsInput" :create-first="createFirstStorageLocation" :new-warehouse="isNew" :disabled="!isStockOwner || stock_saving" :errors="stock_saving_errors?.storage_locations || stock_saving_errors?.storage_locations_enabled" class="mt-4 mb-6" />
                            </v-card-text></v-card>

                            <v-card v-if="showLogisticsOperatorField" class="stitch-modal__card" elevation="0"><v-card-text>
                                <h5
                                    class="stitch-modal__title"
                                >
                                    <v-icon size="16">mdi-truck-outline</v-icon
                                    ><span>{{
                                        $translate("logistics_operator_section")
                                    }}</span>
                                </h5>
                                <p class="text-caption text--secondary mb-2">
                                    {{ $translate("logistics_operator_help") }}
                                </p>
                                <SearchOperator
                                    outlined
                                    v-model="stock.operator"
                                    class="mb-4"
                                    :allow-create="true"
                                    :additional-params="
                                        warehouseOperatorSearchParams
                                    "
                                    :create-modal-params="
                                        warehouseOperatorCreateModalParams
                                    "
                                    :disabled="!isStockOwner"
                                    :readonly="!isStockOwner"
                                    :error-messages="
                                        stock_saving_errors?.operator
                                    "
                                />
                            </v-card-text></v-card
                    ><v-card class="stitch-modal__card" elevation="0"
                        ><v-card-text
                            ><h5 class="stitch-modal__title">
                                <v-icon size="16">mdi-map-marker-outline</v-icon
                                ><span>{{ $translate("labels.address") }}</span>
                            </h5>
                            <AddressForm
                                outlined
                                class="mt-0"
                                :title="null"
                                v-model="stock.address"
                                :readonly="!isStockOwner"
                                :errors="stock_saving_errors?.address"
                                :highlight-mandatory="false"
                                @keydown="handleKeyPress"
                            />
                            <v-textarea
                                outlined
                                class="mt-5"
                                :label="
                                    $translate('labels.delivery_instructions')
                                "
                                :error-messages="
                                    stock_saving_errors?.delivery_instructions
                                "
                                :disabled="!isStockOwner"
                                v-model="stock.delivery_instructions"
                                @keydown="handleKeyPress"
                            /> </v-card-text
                    ></v-card></div
            ></template>
        </template>
        <template slot="bottom">
            <Button
                v-if="showWarehousesGate"
                class="my-2 my-sm-4 w-100 w-sm-auto"
                :text="$translate('buttons.close')"
                @click="cancelEditClicked"
                ghost
            />
            <template v-else>
                <Button
                    :text="
                        isStockOwner
                            ? $translate('buttons.cancel')
                            : $translate('buttons.close')
                    "
                    class="my-2 my-sm-4 w-100 w-sm-auto"
                    :disabled="stock_saving"
                    @click="cancelEditClicked"
                    ghost
                />

                <Button
                    class="my-2 my-sm-4 w-100 w-sm-auto ml-sm-3"
                    :text="save_text"
                    :loading="stock_saving"
                    :disabled="stock_saving"
                    @click="saveInformationClicked"
                    v-if="isStockOwner"
                />
            </template>
        </template>
    </ModalContent>
</template>

<script>
import StorageLocationsEditor from "@/components/stock/storage-locations-editor.vue";
import axios from "@/plugins/axios";
import { mapState, mapActions } from "vuex";
import GlobalMixins from "@/mixins/global";
import PremiumFeatureGateWarehouses from "@/components/common/premium-feature-gate-warehouses";
import SearchEstablishment from "@/components/common/search-establishment.vue";
import SearchOperator from "@/components/common/search-operator.vue";
import { canAccessEstablishments } from "@/utils/establishments";

export default {
    name: "ModalStock",
    mixins: [GlobalMixins],
    components: {
        StorageLocationsEditor,
        PremiumFeatureGateWarehouses,
        SearchEstablishment,
        SearchOperator,
    },
    props: {
        params: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapState("editstock", [
            "stock_saving",
            "stock_saving_errors",
        ]),
        isNew() {
            return !this.stock.id;
        },
        isStockOwner() {
            if (this.isNew) {
                return true;
            }
            return this.stock.owned ?? this.params.stock.owned;
        },
        save_text() {
            if (!this.isNew && !this.userHasPermission("stock.change_stock")) {
                return this.$translate("buttons.close");
            }
            if (this.isNew) {
                return this.$translate("buttons.create_warehouse");
            }
            return this.$translate("buttons.save");
        },
        title() {
            return this.stock.id
                ? this.$translate("messages.edit_warehouse")
                : this.$translate("messages.new_warehouse");
        },
        isPremiumSubscription() {
            return this.current_entity?.subscription === "premium";
        },
        showWarehousesGate() {
            return this.isNew && !this.isPremiumSubscription;
        },
        showLogisticsOperatorField() {
            return this.isCustomer && this.isStockOwner && !this.showWarehousesGate;
        },
        showEstablishmentField() {
            return (
                this.isCustomer &&
                !this.showWarehousesGate &&
                canAccessEstablishments(this)
            );
        },
        warehouseOperatorCreateModalParams() {
            const addr =
                this.stock.address && typeof this.stock.address === "object"
                    ? JSON.parse(JSON.stringify(this.stock.address))
                    : {};
            return {
                operatorPrefill: {
                    name: this.stock.name || "",
                    billing_address: addr,
                },
            };
        },
        warehouseOperatorSearchParams() {
            return { connected: false };
        },
    },
    data() {
        let stock = JSON.parse(JSON.stringify(this.params.stock || {}));
        if (stock.operator && typeof stock.operator === "object") {
            stock.operator = stock.operator.id;
        }
        if (stock.establishment && typeof stock.establishment === "object") {
            stock.establishment = stock.establishment.id;
        } else if (stock.establishment == null && stock.establishment_data?.id) {
            stock.establishment = stock.establishment_data.id;
        }
        if (!stock.address) {
            stock.address = {};
        }
        stock.storage_locations = stock.storage_locations || [];
        stock.storage_locations_enabled = Boolean(stock.storage_locations_enabled);
        // Activer le suivi de stock par défaut pour les nouveaux entrepôts
        if (!stock.id && stock.track_stock === undefined) {
            stock.track_stock = true;
        }
        return {
            stock: stock,
            original_track_stock: stock.track_stock, // Sauvegarder la valeur originale
        };
    },
    mounted() {
        this.sanitizeConnectedWarehouseOperator();
        this.prefillWarehouseAddressFromPresetEstablishment();
    },
    watch: {
        "stock.operator"(newOperatorId, _oldOperatorId) {
            this.onStockOperatorChanged(newOperatorId);
        },
        "stock.track_stock"(newValue, oldValue) {
            // Si on désactive le suivi de stock sur un entrepôt existant
            if (
                this.original_track_stock === true &&
                newValue === false &&
                !this.isNew
            ) {
                this.confirmDisableStockTracking();
            }
        },
    },
    methods: Object.assign(
        mapActions("mcl", ["hideModal"]),
        mapActions("editstock", ["fetchStock", "deleteStock", "saveStock"]),
        {
            async createFirstStorageLocation(name) {
                if (this.isNew) {
                    const response = await this.saveStock({ instance: {
                        ...this.stock, storage_locations: [{ name }], storage_locations_enabled: true,
                    } });
                    this.stock = response.data;
                } else {
                    const response = await axios.patch(`/api/stocks/${this.stock.id}/first-storage-location/`, { name });
                    this.stock.storage_locations = response.data.storage_locations;
                    this.stock.storage_locations_enabled = response.data.storage_locations_enabled;
                }
                return this.stock;
            },
            onStorageLocationsInput(locations) {
                this.stock.storage_locations = locations;
                if (locations.some(location => !location.is_unallocated && !location.archived)) {
                    this.stock.storage_locations_enabled = true;
                }
            },
            onEstablishmentInput(value) {
                if (value == null || value === "") {
                    this.stock.establishment = null;
                    return;
                }
                this.stock.establishment =
                    typeof value === "object" ? value.id : value;
                this.prefillWarehouseAddressFromEstablishment(value);
            },

            // Handle Enter key for automatic save
            handleKeyPress(event) {
                if (event.key === "Enter") {
                    event.preventDefault();

                    // Check if we can save
                    if (this.isStockOwner && !this.stock_saving) {
                        this.saveInformationClicked();
                    }
                }
            },

            async saveInformationClicked() {
                if (this.stock_saving) return;
                try {
                    const response = await this.saveStock({
                        instance: this.stock,
                    });
                    if (response.status == 201) {
                        this.addAlert(this.$translate("messages.warehouse_created"));
                    } else {
                        this.addAlert(this.$translate("messages.warehouse_updated"));
                    }
                    this.hideModal({ result: response.data });
                } catch (error) {
                    this.$swal({
                        title: this.$translate("messages.failed_saving_warehouse"),
                        html: this.$utils.resultToSwalContent(this, error),
                        type: "error",
                    });
                }
            },
            cancelEditClicked() {
                this.hideModal();
            },

            /** Whether the trimmed string contains user-entered characters. */
            nonEmptyTrimmed(s) {
                return typeof s === "string" && s.trim().length > 0;
            },

            nonEmptyEmails(emails) {
                return (
                    Array.isArray(emails) &&
                    emails.some((entry) =>
                        this.nonEmptyTrimmed(String(entry ?? "")),
                    )
                );
            },

            /** True if the warehouse address object has meaningful user-visible content from the modal state. */
            warehouseAddressHasUserInput(addr) {
                if (this.warehouseAddressHasDetailsBeyondCountry(addr)) {
                    return true;
                }
                if (!addr || typeof addr !== "object") {
                    return false;
                }
                if (
                    addr.country != null &&
                    String(addr.country).trim().length > 0
                ) {
                    return true;
                }
                return false;
            },

            warehouseAddressHasDetailsBeyondCountry(addr) {
                if (!addr || typeof addr !== "object") {
                    return false;
                }
                if (this.nonEmptyTrimmed(addr.contact_name)) return true;
                if (this.nonEmptyEmails(addr.emails)) return true;
                if (this.nonEmptyTrimmed(addr.line1)) return true;
                if (this.nonEmptyTrimmed(addr.line2)) return true;
                if (this.nonEmptyTrimmed(addr.city)) return true;
                if (this.nonEmptyTrimmed(addr.postal_code)) return true;
                if (this.nonEmptyTrimmed(addr.phone_number)) return true;
                if (this.nonEmptyTrimmed(addr.mobile_phone_number)) return true;
                return false;
            },

            operatorBillingHasUsefulContent(billing) {
                if (!billing || typeof billing !== "object") {
                    return false;
                }
                return this.warehouseAddressHasUserInput(billing);
            },

            mergeOperatorBillingIntoWarehouse(billing, warehouseAddr) {
                const keysToCopy = [
                    "contact_name",
                    "line1",
                    "line2",
                    "city",
                    "country",
                    "postal_code",
                    "phone_number",
                    "mobile_phone_number",
                    "emails",
                ];
                const next = { ...(warehouseAddr || {}) };
                const preservedId =
                    warehouseAddr && warehouseAddr.id != null
                        ? warehouseAddr.id
                        : undefined;
                for (const key of keysToCopy) {
                    if (!Object.prototype.hasOwnProperty.call(billing || {}, key)) {
                        continue;
                    }
                    const value = billing[key];
                    next[key] = Array.isArray(value) ? [...value] : value;
                }
                if (preservedId != null) {
                    next.id = preservedId;
                } else {
                    delete next.id;
                }
                return next;
            },

            async prefillWarehouseAddressFromPresetEstablishment() {
                if (!this.isNew || !this.stock.establishment) {
                    return;
                }
                const original = this.params.stock || {};
                const preset =
                    (typeof original.establishment === "object" &&
                        original.establishment) ||
                    original.establishment_data ||
                    this.stock.establishment;
                await this.prefillWarehouseAddressFromEstablishment(preset);
            },

            async prefillWarehouseAddressFromEstablishment(value) {
                if (!this.isStockOwner) {
                    return;
                }
                const establishmentId =
                    typeof value === "object" ? value.id : value;
                if (!establishmentId) {
                    return;
                }

                let address =
                    typeof value === "object" &&
                    value.address &&
                    typeof value.address === "object"
                        ? value.address
                        : null;
                if (!this.warehouseAddressHasDetailsBeyondCountry(address)) {
                    try {
                        const response = await axios.get(
                            `/api/establishments/${establishmentId}/`,
                        );
                        if (this.stock.establishment !== establishmentId) {
                            return;
                        }
                        address = response.data?.address || null;
                    } catch (_error) {
                        return;
                    }
                }
                if (!this.warehouseAddressHasDetailsBeyondCountry(address)) {
                    return;
                }

                if (
                    this.warehouseAddressHasDetailsBeyondCountry(
                        this.stock.address,
                    )
                ) {
                    const confirmed = await this.$swal({
                        title: this.$translate(
                            "messages.copy_establishment_address_title",
                        ),
                        html: this.$translate(
                            "messages.copy_establishment_address_prompt",
                        ),
                        type: "question",
                        showCancelButton: true,
                        confirmButtonText: this.$translate(
                            "messages.copy_establishment_address_confirm",
                        ),
                        cancelButtonText: this.$translate(
                            "messages.copy_establishment_address_keep",
                        ),
                    });
                    if (!confirmed.value) {
                        return;
                    }
                    if (this.stock.establishment !== establishmentId) {
                        return;
                    }
                }

                this.stock.address = this.mergeOperatorBillingIntoWarehouse(
                    address,
                    this.stock.address || {},
                );
            },

            async onStockOperatorChanged(newOperatorId) {
                if (!this.showLogisticsOperatorField || !this.isStockOwner) return;
                if (!newOperatorId) return;

                const targetId = newOperatorId;
                try {
                    const response = await axios.get(`/api/operators/${targetId}/`);
                    if (this.stock.operator !== targetId) return;

                    if (response.data?.entity) {
                        this.stock.operator = null;
                        this.$swal({
                            title: this.$translate(
                                "messages.connected_operator_not_allowed_title",
                            ),
                            text: this.$translate(
                                "messages.connected_operator_not_allowed_text",
                            ),
                            type: "warning",
                        });
                        return;
                    }

                    const billing = response.data?.billing_address;
                    if (!this.operatorBillingHasUsefulContent(billing)) return;

                    const hasInput = this.warehouseAddressHasUserInput(
                        this.stock.address,
                    );
                    if (hasInput) {
                        const confirmed = await this.$swal({
                            title: this.$translate(
                                "messages.copy_operator_address_title",
                            ),
                            html: this.$translate(
                                "messages.copy_operator_address_prompt",
                            ),
                            type: "question",
                            showCancelButton: true,
                            confirmButtonText: this.$translate(
                                "messages.copy_operator_address_confirm",
                            ),
                            cancelButtonText: this.$translate(
                                "messages.copy_operator_address_keep",
                            ),
                        });
                        if (!confirmed.value) return;
                    }

                    this.stock.address = this.mergeOperatorBillingIntoWarehouse(
                        billing,
                        this.stock.address || {},
                    );
                } catch (_e) {
                    /* Selection remains valid without copying address */
                }
            },

            async sanitizeConnectedWarehouseOperator() {
                if (!this.showLogisticsOperatorField || !this.stock.operator) {
                    return;
                }
                try {
                    const response = await axios.get(
                        `/api/operators/${this.stock.operator}/`,
                    );
                    if (!response.data?.entity) {
                        return;
                    }
                    this.stock.operator = null;
                    this.addAlert({
                        text: this.$translate(
                            "messages.connected_operator_cleared",
                        ),
                        type: "warning",
                    });
                } catch (_e) {
                    /* Keep current value; save will fail server-side if invalid */
                }
            },

            async confirmDisableStockTracking() {
                const result = await this.$swal({
                    title: this.$translate("disable_stock_tracking_title"),
                    html: this.$translate("disable_stock_tracking_warning"),
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonText: this.$translate(
                        "disable_stock_tracking_confirm"
                    ),
                    cancelButtonText: this.$translate(
                        "disable_stock_tracking_cancel"
                    ),
                    confirmButtonColor: "#d33",
                    cancelButtonColor: "#3085d6",
                });
                if (!result.value) {
                    // L'utilisateur a annulé, remettre la valeur à true
                    this.stock.track_stock = true;
                }
            },
        }
    ),
    i18n: {
        messages: {
            en: {
                storageLocationsTitle: "Storage locations",
                storageLocationsEnabled: "Track stock by location",
                labels: {
                    name: "Name",
                    code_automatically_generated: "Code (automatically generated if empty)",
                    address: "Address (optional)",
                    delivery_instructions: "Delivery instructions",
                    establishment: "Establishment",
                },
                buttons: {
                    cancel: "Cancel",
                    close: "Close",
                    create_warehouse: "Create warehouse",
                    save: "Save",
                },
                messages: {
                    edit_warehouse: "Edit warehouse",
                    new_warehouse: "New warehouse",
                    error: "Error",
                    warehouse_created: "Warehouse created",
                    warehouse_updated: "Warehouse updated",
                    failed_saving_warehouse: "Failed saving warehouse",
                    copy_operator_address_title: "Replace warehouse address?",
                    copy_operator_address_prompt:
                        "You already entered warehouse address details. Replace them with this logistics provider's address?",
                    copy_operator_address_confirm: "Replace with provider address",
                    copy_operator_address_keep: "Keep current address",
                    copy_establishment_address_title: "Replace warehouse address?",
                    copy_establishment_address_prompt:
                        "You already entered warehouse address details. Replace them with this establishment's address?",
                    copy_establishment_address_confirm: "Replace with establishment address",
                    copy_establishment_address_keep: "Keep current address",
                    connected_operator_not_allowed_title:
                        "Connected provider not allowed",
                    connected_operator_not_allowed_text:
                        "A connected Safetee logistics provider cannot be assigned to your own warehouse. Use an offline contact entry instead, or work from their delegated warehouse.",
                    connected_operator_cleared:
                        "The connected logistics provider was removed from this warehouse. Only offline contacts can be assigned to your own warehouses.",
                },
                stock_tracking: "Stock tracking",
                enable_stock_tracking:
                    "Enable stock tracking for this warehouse",
                stock_tracking_explanation:
                    "When enabled, the system will track inventory levels for products stored in this warehouse. This allows you to monitor stock quantities, receive low stock alerts, and manage inventory more effectively. If tracking is not enabled, shipments leaving this warehouse will ignore stock constraints.",
                disable_stock_tracking_title: "Disable stock tracking?",
                disable_stock_tracking_warning:
                    "This warehouse currently has stock tracking enabled. Disabling it may cause discrepancies in product stock levels and affect inventory management. Are you sure you want to continue?",
                disable_stock_tracking_confirm: "Yes, disable tracking",
                disable_stock_tracking_cancel: "Cancel",
                required: "Required",
                logistics_operator_section: "Delegated logistics",
                logistics_operator_help:
                    "Optional: assign an offline logistics contact for this warehouse (e.g. for delivery notes). Connected Safetee providers cannot be assigned to your own warehouses.",
            },
            fr: {
                storageLocationsTitle: "Lieux de stockage",
                storageLocationsEnabled: "Suivre le stock par lieu",
                labels: {
                    name: "Nom",
                    code_automatically_generated: "Code (généré automatiquement si vide)",
                    address: "Adresse (facultative)",
                    delivery_instructions: "Instructions de livraison",
                    establishment: "Établissement",
                },
                buttons: {
                    cancel: "Annuler",
                    close: "Fermer",
                    create_warehouse: "Créer un entrepôt",
                    save: "Enregistrer",
                },
                messages: {
                    edit_warehouse: "Modifier l'entrepôt",
                    new_warehouse: "Nouvel entrepôt",
                    error: "Erreur",
                    warehouse_created: "Entrepôt créé",
                    warehouse_updated: "Entrepôt mis à jour",
                    failed_saving_warehouse: "Erreur lors de la sauvegarde de l'entrepôt",
                    copy_operator_address_title: "Remplacer l'adresse de l'entrepôt ?",
                    copy_operator_address_prompt:
                        "Vous avez déjà saisi des informations d'adresse pour cet entrepôt. Souhaitez-vous les remplacer par l'adresse de ce prestataire logistique ?",
                    copy_operator_address_confirm: "Utiliser l'adresse du prestataire",
                    copy_operator_address_keep: "Garder l'adresse saisie",
                    copy_establishment_address_title:
                        "Remplacer l'adresse de l'entrepôt ?",
                    copy_establishment_address_prompt:
                        "Vous avez déjà saisi des informations d'adresse pour cet entrepôt. Souhaitez-vous les remplacer par l'adresse de cet établissement ?",
                    copy_establishment_address_confirm:
                        "Utiliser l'adresse de l'établissement",
                    copy_establishment_address_keep: "Garder l'adresse saisie",
                    connected_operator_not_allowed_title:
                        "Prestataire connecté non autorisé",
                    connected_operator_not_allowed_text:
                        "Un prestataire logistique connecté sur Safetee ne peut pas être assigné à votre entrepôt personnel. Utilisez une fiche hors connexion ou travaillez depuis son entrepôt délégué.",
                    connected_operator_cleared:
                        "Le prestataire logistique connecté a été retiré de cet entrepôt. Seuls les contacts hors connexion peuvent être assignés à vos entrepôts personnels.",
                },
                stock_tracking: "Suivi de stock",
                enable_stock_tracking:
                    "Activer le suivi de stock pour cet entrepôt",
                stock_tracking_explanation:
                    "Lorsque activé, le système suivra les niveaux d'inventaire des produits stockés dans cet entrepôt. Cela vous permet de surveiller les quantités en stock, de recevoir des alertes de stock faible et de gérer l'inventaire plus efficacement. Si le suivi n'est pas activé, les expéditions partant de cet entrepôt ignoreront les contraintes de stock.",
                disable_stock_tracking_title: "Désactiver le suivi de stock ?",
                disable_stock_tracking_warning:
                    "Cet entrepôt a actuellement le suivi de stock activé. Le désactiver peut créer des écarts dans les niveaux de stock des produits et affecter la gestion de l'inventaire. Êtes-vous sûr de vouloir continuer ?",
                disable_stock_tracking_confirm: "Oui, désactiver le suivi",
                disable_stock_tracking_cancel: "Annuler",
                required: "Requis",
                logistics_operator_section: "Logistique déléguée",
                logistics_operator_help:
                    "Optionnel : désignez un contact logistique hors connexion pour cet entrepôt (ex. destinataire des bons de livraison). Les prestataires connectés sur Safetee ne peuvent pas être assignés à vos entrepôts personnels.",
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.stitch-modal { gap: 24px; }

@import "@/assets/css/_stitch-form.scss";
</style>
